import * as yup from 'yup';

interface LeasingFormSchema {
  messages: {
    number: string;
    integer: string;
    min: string;
    max: string;
  };
  downPayment: {
    transform: (value: string) => number;
    min: number;
    max: number;
  };
}

const leasingFormSchema = ({ messages, downPayment }: LeasingFormSchema) => {
  return yup.object({
    downPayment: yup
      .number()
      .transform((parsedValue, origValue) => downPayment.transform(origValue))
      .typeError(messages.number)
      .integer(messages.integer)
      .min(downPayment.min, messages.min)
      .max(downPayment.max, messages.max),
  });
};

export default leasingFormSchema;
